import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@maui/elements'
import {
  ActorSearchResult,
  MalwareSearchResult,
  CveSearchResult,
  IndicatorSearchResult,
  ReportSearchResult,
  CampaignSearchResult
} from './searchResultComp'

const ActorSearchResultTemplate = (data) => <ActorSearchResult {...data}/>
const MalwareSearchResultTemplate = (data) => <MalwareSearchResult {...data}/>
const CveSearchResultTemplate = (data) => <CveSearchResult {...data}/>
const IndicatorSearchResultTemplate = (data) => <IndicatorSearchResult {...data} />
const ReportSearchResultTemplate = (data) => <ReportSearchResult {...data} />
const CampaignSearchResultTemplate = (data) => <CampaignSearchResult {...data}/>

const compMap = {
  'threat-actor': ActorSearchResultTemplate,
  malware: MalwareSearchResultTemplate,
  vuln: CveSearchResultTemplate,
  fqdn: IndicatorSearchResultTemplate,
  md5: IndicatorSearchResultTemplate,
  sha256: IndicatorSearchResultTemplate,
  sha1: IndicatorSearchResultTemplate,
  ipv4: IndicatorSearchResultTemplate,
  url: IndicatorSearchResultTemplate,
  indicator: IndicatorSearchResultTemplate,
  report: ReportSearchResultTemplate,
  campaign: CampaignSearchResultTemplate
}

export const SearchResult = ({ type, data }) => {
  if (!type) return null
  const CompTemplate = compMap[type] || null
  return (
    <Box width='100%'>
      <Box padding='spacePaddingXLarge' backgroundColor='colorBackgroundPage'>
        <CompTemplate data={data}/>
      </Box>
    </Box>
  )
}

SearchResult.propTypes = {
  data: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired
}
